import React from 'react';
import { renderRoutes } from 'react-router-config';

import Home from '../HomePage/Home'; /*主頁*/

/*
利用lazy loading及dynamic動態載入named export components
ex:const Announcement = React.lazy(() =>
  import("../Page/Announce/Announcement/Announcement").then(importedModule => ({
    default: importedModule.Announcement
  }))
);
如果僅是default export僅需使用React.lazy引用即可
ex: const OtherComponent = React.lazy(() => import('./OtherComponent'));
*/
// const HomeAbout = React.lazy(
//     () => import(/* webpackChunkName: "Announcement" */
//         '../HomePage/HomeAbout'));

const PrFormInf = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        'src/Page/FormBasic/PrFormInf'));

const HomeAbout = React.lazy(
    () => import(/* webpackChunkName: "Announcement" */
        '../HomePage/HomeAbout'));

const AnnouncementQuery = React.lazy(
    () => import(/* webpackChunkName: "Announcement" */
        '../Page/Announce/Announcement/Announcement'));

const PrApplyPlanPersonalInformationCheck = React.lazy(
    () => import(/* webpackChunkName: "PrApplyPlanPersonalInformationCheck" */
        '../HomePage/SelectPlan/PrApplyPlanPersonalInformationCheck'));

const SelectPlan = React.lazy(
    () => import(/* webpackChunkName: "SelectPlan" */
        '../HomePage/SelectPlan/SelectPlan'));


const MyCaseFolder = React.lazy(
    () => import(/* webpackChunkName: "MyCaseFolder" */
        '../HomePage/MyCaseFolder/MyCaseFolder'));

const EmpUserMdf = React.lazy(
    () => import(/* webpackChunkName: "EmpUserMdf" */
        '../Page/EmpUserMdf/EmpUserMdf'));

const MailLogQuery = React.lazy(
    () => import(/* webpackChunkName: "Mail" */
        '../Page/Mail/MailLog/MailLog'));

const MailRoleQuery = React.lazy(
    () => import(/* webpackChunkName: "Mail" */
        '../Page/Mail/MailRole/MailRole'));

const MailSetQuery = React.lazy(
    () => import(/* webpackChunkName: "Mail" */
        '../Page/Mail/MailSet/MailSet'));

const MailQueueQuery = React.lazy(
    () => import(/* webpackChunkName: "Mail" */
        '../Page/Mail/MailQueue/MailQueue'));

const EFormSetQuery = React.lazy(
    () => import(/* webpackChunkName: "EForm" */
        '../Page/EFormModule/EFormSet/EFormSet'));

const EFormQuery = React.lazy(
    () => import(/* webpackChunkName: "EForm" */
        '../Page/EFormModule/EForm/EForm'));
const EFormFlow = React.lazy(
    () => import(/* webpackChunkName: "EForm" */
        '../Page/EFormModule/EFormFlow/EFormFlow'));

const ActiveFlow = React.lazy(
    () => import(/* webpackChunkName: "Flow" */
        '../Page/FlowModule/ActiveFlow/ActiveFlow'));

const FlowRoleQuery = React.lazy(
    () => import(/* webpackChunkName: "Flow" */
        '../Page/FlowModule/FlowRole/FlowRole'));

const FlowSetQuery = React.lazy(
    () => import(/* webpackChunkName: "Flow" */
        '../Page/FlowModule/FlowSet/FlowSet'));

const AppsettingQuery = React.lazy(
    () => import(/* webpackChunkName: "Spec" */
        '../Page/Spec/Appsetting'));

const LogQuery = React.lazy(
    () => import(/* webpackChunkName: "Spec" */
        '../Page/Spec/Log'));

const SpecAboutLayout = React.lazy(
    () => import(/* webpackChunkName: "Spec" */
        '../Page/Spec/AboutLayout'));

const PDFSplit = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/PDFSplit'));

const DemoCss = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoCss'));

const SampleJS = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/SampleJS/SampleJS'));

const SampleDocEncrypt = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/SampleDocEncrypt'));

const SamplePdfViewer = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/SamplePdfViewer'));

const DemoEncryptDecrypt = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoEncryptDecrypt'));

const ResourceUsageQuery = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/ResourceUsage/ResourceUsage'));

const DemoBarcode = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoBarcode'));

const DemoChart = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoChart'));

const CustomComponent = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/CustomComponent'));

const DemoGrid = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoGrid'));

const DemoMasterDetailGrid = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoMasterDetailGrid/DemoMasterDetailGrid'));

const DacQuery = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/Dac'));

const ExportWordReport = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/ExportWordReport'));

const ExportExcelReport = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/ExportExcelReport'));

const FlowApi = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/FlowApi'));

const SDOApi = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/SDOApi'));

const Eform = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/Eform'));

const DemoEnjoyHint = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoEnjoyHint'));

const SampleFTP = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/SampleFTP'));

const SampleAppCode = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/SampleAppCode'));

const Calendar = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        '../Page/Sample/DemoCalendar/DemoCalendar'));

const DimRoleQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/DimRole/DimRole'));

const SqlLogQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/SqlLog/SqlLog'));

const MailAuditQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/MailAudit/MailAudit'));

const ApiLogQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/ApiLog/ApiLog'));

const TableExportExcelQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/TableExportExcel/TableExportExcel'));

const SetFunctionQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/SetFunction/SetFunction'));

const WorkingDayQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/WorkingDay/WorkingDay'));

const EmpOrg = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/EmpOrg/EmpOrg'));

const CertificateBindingQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/CertificateBinding/CertificateBinding'));

const DimRightQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/DimRight/DimRight'));

const EmpUserQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/EmpUser/EmpUser'));

const EmpUserReviewQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/EmpUserReview/EmpUserReview'));

const EmpAgentQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/EmpAgent/EmpAgent'));

const SetParamQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/SetParam/SetParam'));

const AccRightMan = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/AccRightMan/AccRightMan'));

const SysActionLogQuery = React.lazy(
    () => import(/* webpackChunkName: "Sysop" */
        '../Page/Sysop/SysActionLog/SysActionLog'));

const FormContainer = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        'src/Page/FormBasic/FormContainer'));

// const FAQ = React.lazy(
//     () => import(/* webpackChunkName: "Demo" */
//         'src/Page/FormBasic/FAQ'));

const PrApplyFinishInf = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        'src/Page/PrApplyFinishInf/PrApplyFinishInf'));

const DemoForm = React.lazy(
    () => import(/* webpackChunkName: "Demo" */
        'src/Page/FormBasic/Demo/DemoSubForm')
        .then(module => ({ default: module.DemoSubForm })));

const PageNotFound = React.lazy(
    () => import(/* webpackChunkName: "PageNotFound" */
        '../Basic/PageNotFound'));

const PageLoading = React.lazy(
    () => import(/* webpackChunkName: "PageLoading" */
        '../Basic/PageLoading'));

const HomeRoute = () => {
    let route = []
    routes.forEach(p => { route = route.concat(p.routes ? p.routes : p) });

    return (
        <Home>
            {renderRoutes(route)}
        </Home>
    );
}

export default HomeRoute;


export const routes = [
    { exact: true, path: "/Home/", component: HomeAbout, breadcrumbName: '關於' },
    /* 新增申請案件 */
    {
        path: "/Home/SelectPlan/PrApplyPlanPersonalInformationCheck", component: PrApplyPlanPersonalInformationCheck, breadcrumbName: '新增申請案件'
    },
    /* 新增申請案件 */
    {
        path: "/Home/SelectPlan", component: SelectPlan, breadcrumbName: '新增申請案件'
    },

    /* 我的案件 */
    {
        path: "/Home/MyCaseFolder", component: MyCaseFolder, breadcrumbName: '案件夾'
    },
    /* 帳號資料修改 */
    {
        path: "/Home/EmpUserMdf", component: EmpUserMdf, breadcrumbName: '帳號資料修改'
    },
    /* 公告模組 */
    {
        path: "/Home/Announce/Announcement/", breadcrumbName: '公告模組', routes: [
            { exact: true, path: "/Home/Announce/Announcement/Query", component: AnnouncementQuery, breadcrumbName: '公告設定' },
        ]
    },
    /* 郵寄模組 */
    {
        path: "/Home/MailModule/", breadcrumbName: '郵件模組', routes: [
            { exact: true, path: "/Home/MailModule/MailLog/Query", component: MailLogQuery, breadcrumbName: '郵件日誌' },
            { exact: true, path: "/Home/MailModule/MailQueue/Query", component: MailQueueQuery, breadcrumbName: '郵寄排程' },
            { exact: true, path: "/Home/MailModule/MailRole/Query", component: MailRoleQuery, breadcrumbName: '郵件角色' },
            { exact: true, path: "/Home/MailModule/MailSet/Query", component: MailSetQuery, breadcrumbName: '郵件範本' },
        ]
    },
    /* 表單模組 */
    {
        path: "/Home/eFormModule/", breadcrumbName: '表單模組', routes: [
            { exact: true, path: "/Home/eFormModule/eFormSet/Query", component: EFormSetQuery, breadcrumbName: '表單設定' },
            { exact: true, path: "/Home/eFormModule/eForm/Query", component: EFormQuery, breadcrumbName: '表單填寫' },
            { exact: true, path: "/Home/eFormModule/eForm/QueryFlow", component: EFormFlow, breadcrumbName: '表單簽核' },
        ]
    },
    /* 流程模組 */
    {
        path: "/Home/FlowModule/", breadcrumbName: '流程模組', routes: [
            { exact: true, path: "/Home/FlowModule/ActiveFlow/Query", component: ActiveFlow, breadcrumbName: '流程日誌' },
            { exact: true, path: "/Home/FlowModule/FlowRole/Query", component: FlowRoleQuery, breadcrumbName: '流程角色' },
            { exact: true, path: "/Home/FlowModule/FlowSet/Query", component: FlowSetQuery, breadcrumbName: '流程設定' },
        ]
    },
    /* 投資人清單 */
    {
        path: "/Home/Spec/", breadcrumbName: '架構規範', routes: [
            { exact: true, path: "/Home/Spec/Spec/AboutWebconfig", component: AppsettingQuery, breadcrumbName: 'appSettings.json' },
            { exact: true, path: "/Home/Spec/Spec/AboutLog", component: LogQuery, breadcrumbName: 'Log' },
            { exact: true, path: "/Home/Spec/Spec/AboutLayout", component: SpecAboutLayout, breadcrumbName: '版面' }
        ]
    },
    /* 範例實作 */
    {
        path: "/Home/Sample/", breadcrumbName: '範例實作', routes: [
            { exact: true, path: "/Home/Sample/Demo/PDFSplit", component: PDFSplit, breadcrumbName: 'PDF檔案分割' },
            { exact: true, path: "/Home/Sample/Demo/SampleCSS", component: DemoCss, breadcrumbName: 'CSS' },
            { exact: true, path: "/Home/Sample/Demo/SampleJS/SampleJS", component: SampleJS, breadcrumbName: 'Javascript' },
            { exact: true, path: "/Home/Sample/Demo/SampleDocEncrypt", component: SampleDocEncrypt, breadcrumbName: '文件加密' },
            { exact: true, path: "/Home/Sample/Demo/SamplePdfViewer", component: SamplePdfViewer, breadcrumbName: 'PDF呈現範例' },
            { exact: true, path: "/Home/Sample/Demo/SampleEncryptDecrypt", component: DemoEncryptDecrypt, breadcrumbName: '加解密範例' },
            { exact: true, path: "/Home/Sample/Demo/SampleResourceUsage", component: ResourceUsageQuery, breadcrumbName: '資源使用狀況' },
            { exact: true, path: "/Home/Sample/Demo/SampleBarcode", component: DemoBarcode, breadcrumbName: '條碼讀取' },
            { exact: true, path: "/Home/Sample/Demo/SampleChart", component: DemoChart, breadcrumbName: '圖表範例' },
            { exact: true, path: "/Home/Sample/Demo/SampleUsercontrol", component: CustomComponent, breadcrumbName: '自訂控制項' },
            { exact: true, path: "/Home/Sample/Demo/SampleGrid", component: DemoGrid, breadcrumbName: 'Grid' },
            { exact: true, path: "/Home/Sample/Demo/SampleMasterDetailGrid", component: DemoMasterDetailGrid, breadcrumbName: 'DemoMasterDetailGrid' },
            { exact: true, path: "/Home/Sample/Demo/SampleDac", component: DacQuery, breadcrumbName: 'Dac' },
            { exact: true, path: "/Home/Sample/ExportWordReport/ExportWordReport", component: ExportWordReport, breadcrumbName: 'Word報表套版範例' },
            { exact: true, path: "/Home/Sample/ExportExcelReport/ExportExcelReport", component: ExportExcelReport, breadcrumbName: 'Excel報表套版範例' },
            { exact: true, path: "/Home/Sample/Demo/SampleFlowApi", component: FlowApi, breadcrumbName: '流程api' },
            { exact: true, path: "/Home/Sample/Demo/SampleApi", component: SDOApi, breadcrumbName: 'SDO API' },
            { exact: true, path: "/Home/Sample/Demo/SampleEform", component: Eform, breadcrumbName: '動態表單' },
            { exact: true, path: "/Home/Sample/Demo/SampleEnjoyHint", component: DemoEnjoyHint, breadcrumbName: '網站引導工具' },
            { exact: true, path: "/Home/Sample/Demo/SampleFTP", component: SampleFTP, breadcrumbName: 'FTP範例程式' },
            { exact: true, path: "/Home/Sample/Demo/SampleAppCode", component: SampleAppCode, breadcrumbName: 'App_Code' },
            { exact: true, path: "/Home/Sample/Demo/SampleCalendar", component: Calendar, breadcrumbName: '行事曆' },
        ]
    },
    /* 系統管理 */
    {
        path: "/Home/Sysop/", breadcrumbName: '系統管理', routes: [
            { exact: true, path: "/Home/Sysop/MailAudit/Query", component: MailAuditQuery, breadcrumbName: '稽核mail設定' },
            { exact: true, path: "/Home/Sysop/DimRole/Query", component: DimRoleQuery, breadcrumbName: '角色' },
            { exact: true, path: "/Home/Sysop/SqlLog/Query", component: SqlLogQuery, breadcrumbName: 'SQL日誌' },
            { exact: true, path: "/Home/Sysop/ApiLog/Query", component: ApiLogQuery, breadcrumbName: 'API日誌' },
            { exact: true, path: "/Home/Sysop/TableExportExcel/Query", component: TableExportExcelQuery, breadcrumbName: '表格匯出Excel檔案' },
            { exact: true, path: "/Home/Sysop/SetFunction/Query", component: SetFunctionQuery, breadcrumbName: '功能' },
            { exact: true, path: "/Home/Sysop/WorkingDay/Query", component: WorkingDayQuery, breadcrumbName: '工作日設定' },
            { exact: true, path: "/Home/Sysop/EmpOrg/Query", component: EmpOrg, breadcrumbName: '組織' },
            { exact: true, path: "/Home/Sysop/CertificateBinding/Query", component: CertificateBindingQuery, breadcrumbName: '憑證綁定' },
            { exact: true, path: "/Home/Sysop/DimRight/Query", component: DimRightQuery, breadcrumbName: '權利' },
            { exact: true, path: "/Home/Sysop/EmpUser/Query", component: EmpUserQuery, breadcrumbName: '使用者' },
            { exact: true, path: "/Home/Sysop/EmpAgent/Query", component: EmpAgentQuery, breadcrumbName: '代理人' },
            { exact: true, path: "/Home/Sysop/EmpUserReview/Query", component: EmpUserReviewQuery, breadcrumbName: '使用者異動審核' },
            { exact: true, path: "/Home/Sysop/SetParam/Query", component: SetParamQuery, breadcrumbName: '系統參數' },
            { exact: true, path: "/Home/Sysop/AccRightMan/AccRightMan", component: AccRightMan, breadcrumbName: '帳號權限管理' },
            { exact: true, path: "/Home/Sysop/SysActionLog/Query", component: SysActionLogQuery, breadcrumbName: '使用者操作日誌' },
        ],
    },
    { exact: true, path: "/Home/PrFormInf", component: PrFormInf },
    { exact: true, path: "/Home/DemoForm", component: DemoForm },
    { exact: true, path: "/Home/FormContainer", component: FormContainer },
    { exact: true, path: "/Home/ApplyFinish", component: PrApplyFinishInf },
    // { exact: true, path: "/FAQ", component: FAQ },
    { exact: true, path: "*", component: PageNotFound }
];